/**
 * Lazy loads Motion's (motion.dev) domMax feature bundle for animations.
 * domMax includes layout animations, drag, scroll triggers, and other DOM-based features.
 * Used with <LazyMotion> to reduce bundle size by loading animation features only when needed.
 * docs: https://motion.dev/docs/react-reduce-bundle-size#lazy-loading
 */
export const loadDomMax = () => import('./dom-max').then((res) => res.default);
/**
 * Lazy loads Motion's (motion.dev) domAnimation feature bundle for basic animations.
 * domAnimation includes essential animation features without layout animations or advanced DOM features.
 * Used with <LazyMotion> to reduce bundle size by loading animation features only when needed.
 * docs: https://motion.dev/docs/react-reduce-bundle-size#lazy-loading
 */
export const loadDomAnimation = () => import('./dom-animation').then((res) => res.default);
